import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { OpeningCard } from './opening-card';

export function AudienceMessageSection() {
  const { hookForm } = useJobPostingContext();
  const { getValues } = hookForm;
  const poolOpenings = getValues('pool.openingMessages');

  if (Object.keys(poolOpenings).length <= 1) return null;

  return (
    <>
      <Typography variant="caption">
        <FormattedMessage
          defaultMessage="Audience and Message details"
          description="Audience and Message section title"
        />
      </Typography>

      {Object.entries(poolOpenings).map(([openingId, _opening], index) => (
        <OpeningCard
          key={openingId}
          openingId={openingId}
          isFirstOpening={index === 0}
        />
      ))}
    </>
  );
}
